module.exports = __webpack_public_path__ + "img/g矩形 84@1x.deba3aa7.png";